export function omsCsrfHeader() {
  const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }

  const csrfToken = document.querySelector('meta[name=csrf-token]')
  if (csrfToken) headers['X-CSRF-Token'] = csrfToken.content

  return headers
}
